const PERIOD_MULTIPLIER = {
  // converted to week
  'y' : {
    'y' : 1,
    'm' : 12,
    'w' : 52,
    'eom': 12
  },
  'm' : {
    'y' : 1/12,
    'm' : 1,
    'w' : 4,
    'eom': 1
  },
  'eom' : {
    'y' : 1/12,
    'm' : 1,
    'w' : 4,
    'eom': 1
  },
  'w' : {
    'y' : 1/52,
    'm' : 1/4,
    'w' : 1,
    'eom': 1/4
  }
};
const VALID_TENOR_PERIOD = Object.keys( PERIOD_MULTIPLIER );

export const validatePeriod = function(period) {
  if ( isNaN( period ) ) {
    throw new Error(`Invalid period ${period}`);
  }
};

export const validateUnit = function(unit) {
  if (VALID_TENOR_PERIOD.indexOf(unit) === -1) {
    throw new Error(`Invalid unit ${unit}. Valid units : ${VALID_TENOR_PERIOD}`);
  }
};

export const isValidTenor = function(tenor) {
  if (tenor === "*") {
    return true;
  } else {
    if (tenor.length < 2) {
      return false;
    }

    const tenorUnitIndex = tenor.length - 1;
    const tenorPeriod = tenor.slice(0, tenorUnitIndex);
    const tenorUnit = tenor[tenorUnitIndex];

    try {
      validatePeriod( tenorPeriod );
      validateUnit( tenorUnit );
      return true;
    } catch (e) {
      return false;
    }
  }
};

export const getMultiplier = function(fromUnit, toUnit) {
  validateUnit( fromUnit );
  validateUnit( toUnit );
  return PERIOD_MULTIPLIER[ fromUnit ][ toUnit ];
};

export const isDigit = ( n ) => n >= '0' && n <= '9';

export const splitPeriodAndUnit = ( tenor ) => {
  const period = [];
  const unit = [];

  let checkingPeriod = true;

  for ( let i = 0, n = tenor.length; i < n; i++ ) {
    if ( checkingPeriod ) {
      if ( isDigit( tenor[i] ) ) {
        period.push( tenor[i] );
      } else {
        unit.push( tenor[i] );
        checkingPeriod = false;
      }
    } else {
      if ( isDigit( tenor[i] ) ) {
        throw new Error(`Invalid tenor : ${tenor}!`);
      } else {
        unit.push( tenor[i] );
      }
    }
  }

  return [ Number( period.join('') || 1 ), unit.join('') ];
};

export const numOfPeriods = function(tenor1, tenor2) {
  tenor2 = tenor2 || "m";

  const [ tenor1Period, tenor1Unit ] = splitPeriodAndUnit( tenor1 );
  const [ tenor2Period, tenor2Unit ] = splitPeriodAndUnit( tenor2 );

  const multiplier = getMultiplier( tenor1Unit, tenor2Unit );
  return Math.ceil( tenor1Period * multiplier / tenor2Period );
};
